const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "186px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#ffa726",
    d: "M 89.5,-0.5 C 90.5,-0.5 91.5,-0.5 92.5,-0.5C 92.5,17.8333 92.5,36.1667 92.5,54.5C 87.8599,52.1799 83.1932,49.8466 78.5,47.5C 65.6658,55.0827 52.9991,62.916 40.5,71C 47.5919,74.5459 54.5919,78.0459 61.5,81.5C 54.6745,86.137 47.6745,90.637 40.5,95C 48.0208,98.5926 55.3542,102.426 62.5,106.5C 55.0554,110.727 47.7221,115.227 40.5,120C 58.0477,128.275 75.3811,136.775 92.5,145.5C 92.5,163.5 92.5,181.5 92.5,199.5C 91.8333,199.5 91.1667,199.5 90.5,199.5C 65.0571,184.941 39.3904,170.608 13.5,156.5C 8.89264,118.353 4.22597,80.3525 -0.5,42.5C -0.5,38.8333 -0.5,35.1667 -0.5,31.5C 29.7903,21.405 59.7903,10.7383 89.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb8c01",
    d: "M 92.5,-0.5 C 93.5,-0.5 94.5,-0.5 95.5,-0.5C 125.21,10.7383 155.21,21.405 185.5,31.5C 185.5,35.1667 185.5,38.8333 185.5,42.5C 180.645,79.84 175.978,117.34 171.5,155C 170.728,156.221 169.728,157.221 168.5,158C 143.609,171.608 118.943,185.441 94.5,199.5C 93.8333,199.5 93.1667,199.5 92.5,199.5C 92.5,181.5 92.5,163.5 92.5,145.5C 97.3773,146.937 102.044,148.937 106.5,151.5C 119.299,143.865 131.966,136.031 144.5,128C 137.712,125.106 131.045,121.94 124.5,118.5C 123.702,118.043 123.369,117.376 123.5,116.5C 130.472,112.345 137.472,108.178 144.5,104C 136.979,100.407 129.646,96.574 122.5,92.5C 129.748,88.5897 136.748,84.2564 143.5,79.5C 126.627,70.897 109.627,62.5637 92.5,54.5C 92.5,36.1667 92.5,17.8333 92.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefd",
    d: "M 92.5,54.5 C 109.627,62.5637 126.627,70.897 143.5,79.5C 136.748,84.2564 129.748,88.5897 122.5,92.5C 117.402,96.418 111.902,99.7513 106,102.5C 91.0993,95.5914 76.266,88.5914 61.5,81.5C 54.5919,78.0459 47.5919,74.5459 40.5,71C 52.9991,62.916 65.6658,55.0827 78.5,47.5C 83.1932,49.8466 87.8599,52.1799 92.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fff2de",
    d: "M 61.5,81.5 C 76.266,88.5914 91.0993,95.5914 106,102.5C 111.902,99.7513 117.402,96.418 122.5,92.5C 129.646,96.574 136.979,100.407 144.5,104C 137.472,108.178 130.472,112.345 123.5,116.5C 117.877,120.227 112.044,123.561 106,126.5C 91.5505,119.691 77.0505,113.025 62.5,106.5C 55.3542,102.426 48.0208,98.5926 40.5,95C 47.6745,90.637 54.6745,86.137 61.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdfb0",
    d: "M 62.5,106.5 C 77.0505,113.025 91.5505,119.691 106,126.5C 112.044,123.561 117.877,120.227 123.5,116.5C 123.369,117.376 123.702,118.043 124.5,118.5C 131.045,121.94 137.712,125.106 144.5,128C 131.966,136.031 119.299,143.865 106.5,151.5C 102.044,148.937 97.3773,146.937 92.5,145.5C 75.3811,136.775 58.0477,128.275 40.5,120C 47.7221,115.227 55.0554,110.727 62.5,106.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.86cbe2af079473b8a85ea984deb690f8.svg";
export { ForwardRef as ReactComponent };